import React, { useEffect, useState } from 'react';
import { BOAPI } from '../service/UsersService';

const fmtDate = (d) => new Date(d).toLocaleString('he-IL', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });

// טאב "צור קשר" - פניות חופשיות שמשתמשים שולחים מהאפליקציה (contactUs.tsx).
// לא תור טיקטים מלא, רק רשימה לקריאה + סימון "טופל" (handled) - אותה
// מוסכמת toggle כמו הודעות/פרסומות ובתי עסק, רק שכאן זה לא מחיקה/שחזור
// אלא "טופל"/"לא טופל". ממוין קודם לפי לא-טופל (handled=0 קודם), ואז לפי תאריך
const ContactMessagesTab = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [toggleBusyId, setToggleBusyId] = useState(null);

  useEffect(() => {
    load();
  }, []);

  const load = async () => {
    try {
      setLoading(true);
      setError('');
      const resp = await BOAPI.fetchContactMessages();
      if (resp?.[0]?.[0]?.code === 0) setMessages(resp[1] || []);
      else setError(resp?.[0]?.[0]?.msg || 'שגיאה בטעינת הפניות');
    } catch {
      setError('שגיאה בתקשורת עם השרת');
    } finally {
      setLoading(false);
    }
  };

  const toggleHandled = async (msg) => {
    setToggleBusyId(msg.id);
    setError('');
    try {
      const resp = await BOAPI.markContactMessageHandled(msg.id);
      if (resp?.[0]?.[0]?.code === 0) {
        const handled = !!resp[1]?.[0]?.handled;
        setMessages((prev) => prev.map((m) => (m.id === msg.id ? { ...m, handled } : m)));
      } else {
        setError(resp?.[0]?.[0]?.msg || 'העדכון נכשל');
      }
    } catch {
      setError('שגיאה בתקשורת עם השרת');
    } finally {
      setToggleBusyId(null);
    }
  };

  const pendingCount = messages.filter((m) => !m.handled).length;

  return (
    <div style={s.container}>
      <div style={s.headerRow}>
        <h2 style={s.title}>צור קשר</h2>
        <span style={s.totalBadge}>{pendingCount} ממתינות מתוך {messages.length}</span>
      </div>

      <p style={s.hint}>פניות שמשתמשים שלחו דרך "צור קשר" באפליקציה. אפשר לחזור אליהם דרך הטלפון/מייל שרשום בפרטי המשתמש.</p>

      {error && (
        <div style={s.errorBanner}>❌ {error}
          <button style={s.closeErr} onClick={() => setError('')}>✕</button>
        </div>
      )}

      {loading ? (
        <div style={s.center}>טוען...</div>
      ) : messages.length === 0 ? (
        <div style={s.emptyState}>
          <div style={{ fontSize: 48 }}>📬</div>
          <p style={{ color: '#697386', fontWeight: 600 }}>אין עדיין פניות</p>
        </div>
      ) : (
        <div style={s.list}>
          {messages.map((m) => (
            <div key={m.id} style={{ ...s.card, ...(m.handled ? s.cardHandled : {}) }}>
              <div style={s.cardHeader}>
                <div>
                  <span style={s.userName}>{m.fName} {m.lName}</span>
                  <span style={s.userContact}>{m.phone || m.email || ''}</span>
                </div>
                <span style={s.date}>{fmtDate(m.iTime)}</span>
              </div>
              <p style={s.messageText}>{m.message}</p>
              <div style={s.cardFooter}>
                <span style={{ ...s.statusBadge, ...(m.handled ? s.statusActive : s.statusInactive) }}>
                  {m.handled ? 'טופל' : 'ממתין לטיפול'}
                </span>
                <button
                  style={m.handled ? s.markPendingBtn : s.markHandledBtn}
                  onClick={() => toggleHandled(m)}
                  disabled={toggleBusyId === m.id}
                >
                  {toggleBusyId === m.id ? '...' : m.handled ? 'סימון כלא טופל' : 'סימון כטופל'}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const s = {
  container:    { padding: 20, direction: 'rtl', fontFamily: 'Arial, sans-serif' },
  headerRow:    { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6, flexWrap: 'wrap', gap: 12 },
  title:        { margin: 0, color: '#1a1f36', fontSize: 24, fontWeight: 'bold' },
  totalBadge:   { background: '#e8eaf6', color: '#1f6feb', borderRadius: 12, padding: '4px 12px', fontSize: 13, fontWeight: 700 },
  hint:         { color: '#8792a2', fontSize: 12.5, marginBottom: 18, lineHeight: 1.6 },
  center:       { padding: 40, textAlign: 'center', color: '#999' },
  errorBanner:  { display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#ffebee', color: '#c62828', padding: 14, borderRadius: 6, marginBottom: 16 },
  closeErr:     { background: 'transparent', border: 'none', cursor: 'pointer', color: '#c62828', fontSize: 18 },
  emptyState:   { textAlign: 'center', padding: '60px 0' },

  list:         { display: 'flex', flexDirection: 'column', gap: 12 },
  card:         { border: '1px solid #e3e8ee', borderRadius: 12, padding: 16, background: '#fff' },
  cardHandled:  { background: '#fafbfc', opacity: 0.75 },
  cardHeader:   { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 8, flexWrap: 'wrap', gap: 8 },
  userName:     { fontWeight: 700, color: '#1a1f36', fontSize: 14 },
  userContact:  { color: '#8792a2', fontSize: 12.5, marginRight: 8 },
  date:         { color: '#8792a2', fontSize: 12 },
  messageText:  { color: '#4f566b', fontSize: 13.5, lineHeight: 1.6, margin: '0 0 12px 0', whiteSpace: 'pre-wrap' },
  cardFooter:   { display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 },
  statusBadge:  { display: 'inline-block', borderRadius: 12, padding: '3px 10px', fontSize: 11, fontWeight: 700 },
  statusActive: { background: '#e8f5e9', color: '#2e7d32' },
  statusInactive:{ background: '#fff8e1', color: '#a06d00' },
  markHandledBtn:{ padding: '6px 12px', background: '#e8f5e9', color: '#2e7d32', border: '1px solid #c8e6c9', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 700 },
  markPendingBtn:{ padding: '6px 12px', background: '#fff1f1', color: '#d93838', border: '1px solid #fbc4c4', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 700 },
};

export default ContactMessagesTab;
